import React from 'react';
import { useClusterStore } from '../../state/clusterStore';
import { Cluster } from '@solante/shared';

const clusters: Cluster[] = ['devnet', 'mainnet-beta'];

export const ClusterSwitcher: React.FC = () => {
  const { cluster, setCluster } = useClusterStore();

  return (
    <label className="flex items-center gap-2 rounded-full bg-white/5 px-3 py-1 text-xs text-white/70">
      Cluster
      <select
        className="rounded-full border border-white/10 bg-black/40 px-2 py-1 text-xs text-white focus:outline-none"
        value={cluster}
        onChange={(event) => setCluster(event.target.value as Cluster)}
      >
        {clusters.map((c) => (
          <option key={c} value={c}>
            {c}
          </option>
        ))}
      </select>
    </label>
  );
};
